<p class="modal-title">Pre-retirement healthcare expenses</p>
<div class="modal-close" (click)="onClose()">
    <img alt="Close" src="../../../assets/icons/circle-x.svg" />
</div>
<div class="chart">
    <div id="chartdiv"></div>
    <div class="action-plan">
        <div *ngFor="let detail of expenseDetails">
            <p [innerHTML]="detail"></p>
        </div>
    </div>
</div>
